var map = {
	"./ Philip Ullman, What Dying Feels Like, still from excerpt film, 2020, courtesy of the artist..jpg": 1974,
	"./Emilie Palmelund, COIL, sculpture, 2020, courtesy of the artist.png": 1654,
	"./Henri Mcmaster, ARSINOË, 2020, sculpture, courtesy of the artist.png": 2013,
	"./Ivana Tkalcic.png": 8076,
	"./Jonne Hansson, Heavy Thoughts, still from film, 2019, courtesy of the artist .png": 7214,
	"./Josefina Anjou, Mixed Feelings, Tender & Sharp, section of graphite on paper work, 2020, courtesy of the artist.png": 4279,
	"./Max Olofsson, Scrambled Parrot Singing Livingroom Song, section of digital painting, 2019, courtesy of the artist.png": 3605,
	"./Valentina Butumović, Still Life : Vibrant Matter, part of artistic research work in progress, 2020, courtesy of the artist.png": 6827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6637;